import React from 'react';
import CostForm from "../../forms/CostForm";
import moment from "moment";
import {Button} from "react-materialize";
import * as utils from "../../../utils/utils";
import * as creationActions from "../../../actions/creation";
import Dialog from "react-toolbox/lib/dialog/Dialog";
import * as costActions from "../../../actions/cost";

export default class CostItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogActive: false,
            costItemID: null
        };
    }

    deleteCostItem = (fogID) => {
        if (this.state.costItemID !== null) {
            this.props.dispatch(costActions.remove(this.state.costItemID, fogID));
        }
        this.setState({...this.state, dialogActive: false, costItemID: null});
    };

    render() {
        return (
            <tr>
                <td>{utils.notNullNorUndefined(this.props.item.company)? this.props.item.company.name : ''}</td>
                {/*<td>{this.props.item.currency.name}</td>*/}
                <td>{utils.notNullNorUndefined(this.props.item.creationDate) && moment.unix(this.props.item.creationDate).format('DD/MM/Y')}</td>
                <td>{this.props.item.invoiceNumber}</td>
                <td>{this.props.item.label}</td>
                <td>{utils.money(utils.precisionRound(this.props.item.totalCost), this.props.currency)}</td>
                <td>
                    <Button floating onClick={() => this.props.openDrawer(CostForm, {item: this.props.item, fog: this.props.fog}, creationActions.destroyingnewlyCreatedCost())} icon="edit" className="edit-button" />
                    <Button floating style={{'marginLeft': '5px'}} onClick={() => this.setState({...this.state, dialogActive: true, costItemID: this.props.item.id})} icon="delete" className="delete-button" />
                </td>

                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, costItemID: null}) },
                        { label: "Yes", onClick: () => this.deleteCostItem(this.props.fog.id) }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this Affiliate invoice ?</p>
                </Dialog>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/cost/CostItem.js